import React from 'react';
import { Link } from 'react-router-dom';
import { Mail, Phone, MapPin, Linkedin, Facebook, StarIcon, Instagram } from 'lucide-react';
import { companyInfo } from '../mock';

const ClutchIcon = ({ className }) => (
  <svg
    viewBox="0 0 200 200"
    xmlns="http://www.w3.org/2000/svg"
    className={className}
    aria-hidden="true"
  >
    {/* Outer C */}
    <path
      className="clutch-c transition-colors duration-300"
      fill="#ffffff00"
      stroke="#ffffff"
      strokeWidth="16"
      strokeLinejoin="round"
      d="M100 10
         C50 10 10 50 10 100
         C10 150 50 190 100 190
         C120 190 140 184 156 174
         L140 150
         C128 158 114 162 100 162
         C66 162 38 134 38 100
         C38 66 66 38 100 38
         C114 38 128 42 140 50
         L156 26
         C140 16 120 10 100 10
         Z"
    />

    {/* Red dot */}
    <circle cx="100" cy="100" r="22" fill="#FF3B30" />
  </svg>
);




const Footer = () => {
  const currentYear = new Date().getFullYear();

  const quickLinks = [
    { name: 'Home', path: '/' },
    { name: 'About', path: '/about' },
    { name: 'Services', path: '/services' },
    { name: 'Portfolio', path: '/portfolio' },
    { name: 'Contact', path: '/contact' }
  ];

  const services = [
    'Custom App Development',
    'UI/UX Design',
    'AI Automation & Workflows',
    'Maintenance & Support'
  ]

  const socialLinks = [
    { icon: Linkedin, label: 'LinkedIn',href:"https://www.linkedin.com/company/codifytechllc/posts/?feedView=all" },
    { icon: ClutchIcon, label: 'Clutch',href:"https://clutch.co/profile/codify-tech?utm_source=widget&utm_medium=1&utm_campaign=widget&utm_content=logo&utm_term=" },
    { icon: Instagram, label: 'Instagram', href:"https://www.instagram.com/codifytechllp/" },
    { icon: Facebook, label: 'Facebook',href:"https://www.facebook.com/groups/1357294698430012" },
  ];

  return (
    <footer className="bg-black text-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8 mb-8">
          {/* Company Info */}
          <div className="space-y-4">
            <Link to="/" className="flex items-center space-x-3 group">
              <img 
                src="https://customer-assets.emergentagent.com/job_05e84b19-7036-4de2-87ce-48b47550d58d/artifacts/a930xw2s_codify.png" 
                alt="CodifyTech Logo" 
                className="w-10 h-10 transition-transform duration-300 group-hover:scale-110"
              />
              <span className="text-2xl font-bold tracking-tight">Codify Tech</span>
            </Link>
            <p className="text-gray-400 text-sm leading-relaxed">
              {companyInfo.tagline}
            </p>
            <div className="flex space-x-4">
              {socialLinks.map((social) => (
                <a
                  key={social.label}
                  href={social.href}
                  target="_blank"
                  rel="noopener noreferrer"
                  aria-label={social.label}
                  className="w-10 h-10 flex items-center justify-center rounded-full bg-gray-800 hover:bg-white hover:text-black transition-all duration-300 group"
                >
                  <social.icon className="w-5 h-5" />
                </a>
                
              ))}
            </div>
          </div>

          {/* Quick Links */}
          <div>
            <h3 className="text-lg font-semibold mb-4">Quick Links</h3>
            <ul className="space-y-2">
              {quickLinks.map((link) => (
                <li key={link.path}>
                  <Link
                    to={link.path}
                    className="text-gray-400 hover:text-white transition-colors duration-200 text-sm"
                  >
                    {link.name}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          {/* Services */}
          <div>
            <h3 className="text-lg font-semibold mb-4">Our Services</h3>
            <ul className="space-y-2">
              {services.map((service) => (
                <li key={service}>
                  <span className="text-gray-400 text-sm">{service}</span>
                </li>
              ))}
            </ul>
          </div>

          {/* Contact Info */}
          <div>
            <h3 className="text-lg font-semibold mb-4">Contact Us</h3>
            <ul className="space-y-3">
              <li className="flex items-start space-x-3">
                <Mail className="w-5 h-5 text-gray-400 mt-0.5 flex-shrink-0" />
                <a
                  href={`mailto:${companyInfo.email}`}
                  className="text-gray-400 hover:text-white transition-colors duration-200 text-sm"
                >
                  {companyInfo.email}
                </a>
              </li>
              <li className="flex items-start space-x-3">
                <Phone className="w-5 h-5 text-gray-400 mt-0.5 flex-shrink-0" />
                <a
                  href={`tel:${companyInfo.phone}`}
                  className="text-gray-400 hover:text-white transition-colors duration-200 text-sm"
                >
                  {companyInfo.phone}
                </a>
              </li>
              <li className="flex items-start space-x-3">
                <MapPin className="w-5 h-5 text-gray-400 mt-0.5 flex-shrink-0" />
                <span className="text-gray-400 text-sm">{companyInfo.address}</span>
              </li>
            </ul>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="pt-8 border-t border-gray-800">
          <div className="flex flex-col md:flex-row justify-between items-center space-y-4 md:space-y-0">
            <p className="text-gray-400 text-sm">
              © {currentYear} Codify Tech. All rights reserved.
            </p>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
